import React, { useState, useEffect, useMemo } from 'react'
import { Layout, PageHeader, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AddProjectModal from '../../components/project/AddProjectModal'

import ProjectsTable from '../../components/project/ProjectsTable'
import HeaderNavigation from '../../components/HeaderNavigation'
import { getProjectsAction, projectSelector } from '../../store/projects'
import { userSelector } from '../../store/session'
import './style.css'

const { Content } = Layout

const Projects = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useSelector(userSelector)
  const [showProjectModal, setShowProjectModal] = useState(false)
  const { isAddSuccess } = useSelector(projectSelector)

  const isProjectManager = useMemo(() => user?.role?.type === 'project_manager', [user])
  const isEstimator = useMemo(() => user?.role?.type === 'estimator', [user])

  useEffect(() => {
    if (isAddSuccess) {
      dispatch(getProjectsAction({ pagination: { page: 1, pageSize: 10 } }))
    }
  }, [isAddSuccess])

  const onEstimateClick = (project, estimateId) => {
    navigate(`/estimate?project=${project}&estimateId=${estimateId}`)
  }

  return (
    <Layout>
      <HeaderNavigation activeKey="2" />
      <Content className="site-layout" style={{ padding: '85px 50px', minHeight: '100vh' }}>
        <PageHeader
          ghost={false}
          title="Проекты"
          //subTitle="содержат информацию о смете"
          extra={[
            <Button
              disabled={!isProjectManager && !isEstimator}
              key="1"
              type="primary"
              onClick={() => setShowProjectModal(true)}
            >
              Создать новый проект
            </Button>,
          ]}
        />
        <ProjectsTable onEstimateClick={onEstimateClick} />
        <AddProjectModal
          showModal={showProjectModal}
          onChancel={() => setShowProjectModal(false)}
          onFinish={() => setShowProjectModal(false)}
        />
      </Content>
    </Layout>
  )
}

export default Projects
